/**
 * FICHIER GÉNÉRÉ — ne pas modifier à la main.
 *
 * Produit par `npm run measure:lamps`. Positions des sources lumineuses, en pixels
 * par rapport au CENTRE de l'image source — le repère local d'un sprite à ancre
 * (0,5 · 0,5). Une entrée PAR ROTATION : le bras d'un mât et la face d'un feu se
 * déportent à chaque quart de tour.
 *
 * Règle 15 : une table dérivée d'une mesure ne s'écrit jamais à la main.
 */

/** Diffuseur de chaque lampadaire — LA source du halo. */
export const LAMP_HEADS: Readonly<Record<string, readonly [number, number]>> = {
  streetLight: [-89, -472],
  'streetLight-r1': [123, -476],
  'streetLight-r2': [109, -585],
  'streetLight-r3': [-65, -595],
};

/** Les TROIS ampoules de chaque feu : rouge en haut, ambre au milieu, verte en bas. */
export const TRAFFIC_BULBS: Readonly<
  Record<
    string,
    {
      readonly red: readonly [number, number];
      readonly amber: readonly [number, number];
      readonly green: readonly [number, number];
    }
  >
> = {
  trafficLight: { red: [-62, -516], amber: [-62, -451], green: [-62, -386] },
  'trafficLight-r1': { red: [62, -550], amber: [62, -468], green: [61, -386] },
  'trafficLight-r2': { red: [37, -611], amber: [37, -537], green: [37, -463] },
  'trafficLight-r3': { red: [21, -612], amber: [21, -538], green: [21, -464] },
};
